import { Box } from "@mui/material";

import DynamicTable from "../../../../data/DynamicTable/dynamicTable";
import { AccountsandFinanceurl } from "../../../../config";
import { AccountTypesColumns } from "../../../../data/DynamicTable/Collumns";
import {

  allBanksBankBranchesAccountView,
  allMpesaAccounts,

} from "../../../../data/Axios/queries";
import {

  BankAccountsColumns,
  MpesaAccountsColumns,

} from "../../../../data/DynamicTable/AccountsColumns";

import BankAccountForm from "./form";
import MpesaAccountForm from "./form";
const base_url = AccountsandFinanceurl.uri;
const actions = {
  entity: "Mpesa Accounts",
  isSubRight: true,
  edit: {
    key: "EDIT",
    button_name: "Edit",
    Show_Button: true,
    permission: "EditPermission",
  },
  add: {
    key: "ADD",
    button_name: "Add",
    Show_Button: true,
    permission: "CreatePermission",
  },
      ViewSummary: {
    key: "VIEWACCOUNTSUMMARY",
    button_name: "Account Summary",
    Show_Button: true,
    permission: "CreatePermission",
  },
  activateDeactivate: {
    key: "ACTIVATEDEACTIVATE",
    button_name: "Deactivate",
    Show_Button: false,
    permission: "ActivatePermission",
  },
  showStatus: true,
};
function MpesaAccountTable() {
  return (
    <Box m="2px">
      <DynamicTable
        title="Mpesa Accounts"
        subtitle="Create, view or edit mpesa accounts
        "
        columns={MpesaAccountsColumns}
        FormComponent={MpesaAccountForm}
        query={allMpesaAccounts}
        base_url={base_url}
        actions={actions}
      />
    </Box>
  );
}

export default MpesaAccountTable;
